import React from "react";
import ConfigPanel from "../ConfigPanel";

const ConfigWidget = ({ apiConfig, apiConnected }) => (
  <div className="widget-content-scroll">
    <ConfigPanel
      config={apiConfig || { accountUuid: "", bearerToken: "" }}
      onChange={() => {}}
      onTest={() => {}}
      testResult={apiConnected}
      loading={false}
    />
  </div>
);

export default ConfigWidget;
